export default __webpack_public_path__ + "static/media/icon-help.5427d30f.svg";